import React, { useState } from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import CloseIcon from '@material-ui/icons/Close'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import IconButton from '@material-ui/core/IconButton'
import MarkerIcon from '@material-ui/icons/Room'
import DeleteIcon from '@material-ui/icons/Delete'
import Slide from '@material-ui/core/Slide'
import { LocationMap } from '../../LocationMap'

import { styles } from './styles'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const ConfirmDelete = ({ visible, handleClose, handleOk }) => {
  return (
    <Dialog
      open={visible}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        ต้องการลบข้อมูลละติจูด ลองติจูด
      </DialogTitle>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          ยกเลิก
        </Button>
        <Button onClick={() => handleOk()} color="primary" autoFocus>
          ตกลง
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export const LocationListSignUp = ({
  locations,
  setUpdateLocations,
  setDeleteLocations
}) => {
  const [open, setOpen] = useState(false)
  const [visible, setVisible] = useState(false)
  const [dataIndex, setDataIndex] = useState(null)
  const [location, setLocation] = useState({ lat: 0, lng: 0 })

  // const removeLocations = (index) => {
  //   setDeleteLocations(index)
  // }

  const handleUpdateLocation = () => {
    setUpdateLocations(location)
    setOpen(false)
  }

  const handleClose = () => {
    setVisible(false)
    setDataIndex(null)
  }

  const handleOk = () => {
    setVisible(false)
    setDeleteLocations(dataIndex)
  }

  const onClick = (index) => {
    setVisible(true)
    setDataIndex(index)
  }

  if (locations.length > 0) {
    return (
      <React.Fragment>
        <ConfirmDelete
          visible={visible}
          handleOk={handleOk}
          handleClose={handleClose}
        />
        <List component="nav">
          {locations &&
            locations.map((item, index) => (
              <ListItem key={index.toString()} button>
                <ListItemIcon>
                  <MarkerIcon />
                </ListItemIcon>
                <ListItemText
                  primary={`${item.lat}, ${item.lng}`}
                  secondary={item.address}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    aria-label="Delete"
                    onClick={() => onClick(index)}>
                    <DeleteIcon color="secondary" />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
        </List>

        <Dialog fullScreen open={open} TransitionComponent={Transition}>
          <AppBar position="sticky">
            <Toolbar style={styles.toolbar}>
              <IconButton
                id="btnClose"
                color="inherit"
                aria-label="Menu"
                style={styles.menuButton}
                onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
              <Typography
                id="titlePage"
                variant="h6"
                color="inherit"
                style={styles.grow}>
                Pick your location
              </Typography>
              <Button
                id="btnLocationAdd"
                color="inherit"
                aria-label="Update"
                style={styles.userButton}
                onClick={handleUpdateLocation}>
                <Typography color="inherit">UPDATE</Typography>
              </Button>
            </Toolbar>
          </AppBar>
          <LocationMap location={location} setLocation={setLocation} />
        </Dialog>
      </React.Fragment>
    )
  } else {
    return <div />
  }
}

export default LocationListSignUp



// WEBPACK FOOTER //
// ./src/components/LocationSignUp/LocationListSignUp/index.js